// @flow
import React from 'react';
import classnames from 'classnames';

import {
  ProductService,
  type Service,
} from 'Components/widgets/product-services/product-service/ProductService';

export type Props = {
  services: $ReadOnlyArray<Service>,
  isDesktop: boolean,
};

export const PriceRemoteServiceList = ({ services, isDesktop }: Props) => {
  return (
    <div
      className={classnames('text-base', {
        'w-1/2 px-5': isDesktop,
        'w-full': !isDesktop,
      })}
    >
      {services.map((service: Service) => (
        <ProductService key={service.label} service={service} />
      ))}
      {!isDesktop ? <div style={{ height: '40px' }} /> : null}
    </div>
  );
};
